// routes/AppRoutes.js
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import AppGuard from './AuthGuard';
import { getRouteConfig } from './routeConfig';

// Layout components
import AuthLayout from '../components/Layout/AuthLayout';
import DashBoardLayout from '../components/Layout/DashboardLayout';

const AppRoutes = ({ Component, pageProps }) => {
  const router = useRouter();
  const { isAuthenticated } = useSelector(state => state.auth);
  const routeConfig = getRouteConfig(router.pathname);

  const getLayoutComponent = () => {
    if (!routeConfig || !routeConfig.layout) return null;

    switch (routeConfig.layout) {
    case 'DashBoardLayout':  // ✅ Changed from 'MainLayout' to 'DashBoardLayout'
        return DashBoardLayout;
      case 'AuthLayout':
        return AuthLayout;
      default:
        return null;
    }
  };

  const LayoutComponent = getLayoutComponent();

  return (
    <AppGuard>
      {LayoutComponent ? (
        <LayoutComponent>
          <Component {...pageProps} />
        </LayoutComponent>
      ) : (
        <Component {...pageProps} />
      )}
    </AppGuard>
  );
};

export default AppRoutes;
